// This is just an example,
// so you can safely delete all default props below

export default {
    shopping_cart: 'Mine reisevalg',
    trip: 'Trip',
    group_discount: 'Grupperabatt',
    discount: 'rabatt',
    total: 'Total',
    vat: 'MVA',
    outward_trip: 'Utreise',
    backward_trip: 'Returreise',
    norwegian_krone: 'kr'
}
